import type { Translations } from './zh';

export const fr: Translations = {
  bubble: {
    open: 'Ouvrir le chat',
    close: 'Fermer le chat',
    badge: 'En ligne',
    dragHint: 'Appui long pour déplacer',
  },
  panel: {
    closeAria: 'Fermer la fenêtre de chat',
    languageAria: 'Choisir la langue',
    welcomeFallback: 'Bonjour, comment puis-je vous aider ?',
    quickQuestionsTitle: 'Vous pouvez essayer ces questions',
    quickAskTitle: 'Questions rapides',
    inputPlaceholder: 'Saisissez votre question...',
    sendButton: 'Envoyer',
    sendAria: 'Envoyer le message',
    onlineStatus: 'En ligne',
    thinkingAria: 'Réflexion en cours',
    aiBusyHint: 'L’assistant est en train de répondre, veuillez patienter…',
    leadReopenHint: 'Laissez vos coordonnées ici en cas de besoin',
    startChat: 'Consulter maintenant',
    welcomeQuickHint: 'Aperçu rapide',
    videoPreparing: 'Préparation de la vidéo…',
    newMessageTitle: '💬 Nouveau message',
    newMessageBody: 'Vous avez un nouveau message. Cliquez pour consulter.',
  },
  roles: {
    visitor: 'Visiteur',
    ai: 'Assistant IA',
    human: 'Conseiller',
    system: 'Système',
  },
  web: {
    aiChat: 'Support IA',
    humanChat: 'Conseiller',
    switchToHuman: 'Passer à un conseiller',
    switchToAI: 'Retour à l’IA',
    resetChat: 'Recommencer',
    commonQuestions: 'Questions fréquentes',
    faqTitle: 'Foire aux questions',
    selectLanguage: 'Choisir la langue',
    maximize: 'Agrandir',
    restore: 'Restaurer',
    offlineLabel: 'Hors ligne',
    aiGreeting: 'Bonjour ! Je suis votre assistant IA. Comment puis-je vous aider ?',
    humanGreeting: 'Bonjour, vous êtes maintenant en relation avec un conseiller. Comment puis-je vous aider ?',
    agentOffline: 'Conseiller hors ligne',
    agentOfflineMessage: "Désolé, nos conseillers sont actuellement hors ligne. Veuillez scanner le QR code ci-dessous pour nous contacter via WeChat.",
    wechatPrompt: 'Scanner pour WeChat',
    wechatHint: 'Scannez avec WeChat pour ajouter le conseiller',
    serviceHoursLabel: 'Heures de service : ',
    viewImage: "Voir l'image",
    playVideo: 'Lire la vidéo',
    closeViewer: 'Fermer',
    downloadFile: 'Télécharger',
    fileTypePdf: 'Document PDF',
    fileTypeWord: 'Document Word',
    fileTypeExcel: 'Feuille de calcul Excel',
    fileTypePpt: 'Présentation PowerPoint',
    fileTypeArchive: 'Fichier archive',
    fileTypeGeneric: 'Fichier',
  },
  leadCard: {
    ariaForm: 'Formulaire de contact',
    title: 'Laissez vos coordonnées',
    nameLabel: 'Nom',
    namePlaceholder: 'Votre nom',
    phoneLabel: 'Téléphone',
    phonePlaceholder: 'Votre numéro de téléphone',
    phoneError: 'Veuillez saisir un numéro de téléphone valide',
    submit: 'Envoyer',
    submitting: 'Envoi en cours…',
    dismiss: 'Plus tard',
    success: 'Merci ! Notre conseiller vous contactera très vite.',
  },
};
